import { useMutation } from 'react-query';
import { toIsoDate } from '../../../utils';
import { salesFeeService, removeCache } from '../../../services';
import {
  SalesFeeAddMutationProps,
  SalesFeeAddMutationRequest,
  SalesFeeUpdateMutationProps,
  SalesFeeUpdateMutationRequest,
} from '../../../types';
import { containerTypes } from '../../../const';

export const useSalesFeeAddMutation = () => {
  return useMutation(
    (props: SalesFeeAddMutationProps) => {
      const requestProps: SalesFeeAddMutationRequest = {
        id: props.id,
        activationDate: toIsoDate(
          props.effectiveDate.set({
            hour: 12,
            minute: 0,
            second: 0,
            millisecond: 0,
          }),
        ),
        feeType: props.feeType,
        containers: containerTypes.map((containerType) => ({
          type: containerType.value,
          fee: props[containerType.value],
        })),
      };

      return salesFeeService.add(requestProps);
    },
    {
      onSuccess: () => {
        removeCache(['sales-fee', 'sale', 'key']);
      },
    },
  );
};

export const useSalesFeeUpdateMutation = () => {
  return useMutation(
    (props: SalesFeeUpdateMutationProps) => {
      const requestProps: SalesFeeUpdateMutationRequest = {
        id: props.id,
        activeFeeRecordId: props.activeFeeRecordId,
        feeType: props.feeType,
        containers: containerTypes.map((containerType) => ({
          type: containerType.value,
          fee: props[containerType.value],
        })),
      };

      return salesFeeService.update(requestProps);
    },
    {
      onSuccess: () => {
        removeCache(['sales-fee', 'sale', 'key']);
      },
    },
  );
};
